import ShopServiceModel from '@/models/ShopServiceModel';
import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';

@model.urnResource('deliverable')
@doc.path('/deliverables/{?id}')
export default class DeliverableModel extends ShopServiceModel {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'deliverableShipmentAddresses.shipmentAddress': id;
		'deliverableStatus': id;
		'orderItemUnit': id;
		'orderItemUnit.orderItem.productPricingClientGroup.productPricing.product.entertainment': id;
		'orderItemUnit.orderItem.productPricingClientGroup.productPricing.product.entertainment.entertainmentUrn': Urn;
		'owner': id;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	// @doc.model(DeliverableStatusModel) declare deliverableStatus: DeliverableStatusModel;
	// @doc.model(OrderItemUnitModel) declare orderItemUnit: OrderItemUnitModel;
	// @doc.model(ShippingMethodModel) declare shippingMethod: ShippingMethodModel;
	// @doc.model(ClientModel) declare owner: ClientModel;
}
